import NextLink from "next/link";
import { Text, Button, Box } from "@cruk/cruk-react-components";

import { isPast } from "@fwa/src/utils/timeUtils";
import { MemberSuperTeam } from "@fwa/src/components/MemberSuperTeam";

import { type SuperTeamPageType } from "@fwa/src/types";

export function MemberSuperTeamDonate({
  superTeamPage,
}: {
  superTeamPage: SuperTeamPageType;
}) {
  if (!superTeamPage) return null;

  return (
    <MemberSuperTeam superTeamPage={superTeamPage}>
      <Box paddingVertical="xs" margin="none">
        {superTeamPage.closeDate &&
        isPast(new Date(superTeamPage.closeDate)) ? (
          <Text style={{ lineHeight: "2.5rem" }} textAlign="center">
            Page Closed
          </Text>
        ) : (
          <NextLink
            href={`/donate/${superTeamPage.uniqueId}/details`}
            aria-label={`Donate to ${superTeamPage.title}`}
            data-cta-type="donate"
          >
            <Button as="span" full appearance="secondary">
              Donate
            </Button>
          </NextLink>
        )}
      </Box>
    </MemberSuperTeam>
  );
}

export default MemberSuperTeamDonate;
